module.exports = __webpack_public_path__ + "static/media/mercado-livre.201ffd78.png";